import React from "react"
import { DiggerCard } from "../data/diggers"
import { getDiggerLevel } from "../service/diggerMethods"
import style from "./DiggerIcon.module.scss"

interface Props {
  digger: DiggerCard
}

export const DiggerIconComponent: React.FC<Props> = (props) => {
  const { name, image } = props.digger
  const level = getDiggerLevel(props.digger)

  return (
    <div className={style.diggerCard}>
      <div className={style.imageBox}>
        <img
          src={image ? `/images/diggers/${image}` : "/images/mug128.png"}
          alt="gm logo"
        />
      </div>
      <p>{name}</p>
      <div className={style.badge}>
        <span>{level}</span>
      </div>
    </div>
  )
}
